import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL_2 || '';
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY_2 || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey,{ db: { schema: 'news_crawler' }})